import { Skeleton } from '@modulor/react';

import SkeletonArray from '../SkeletonArray';
import style from './SkeletonSelectDefault.module.scss';

const SkeletonSelectDefault = () => (
  <div className={style.container}>
    <Skeleton width="100%" height={56} borderRadius={12} marginBottom={12} />
    <div className={style.wrapper}>
      <SkeletonArray length={3}>
        <Skeleton width={61} height={32} borderRadius={60} marginBottom={16} />
      </SkeletonArray>
    </div>
    <SkeletonArray length={3}>
      <Skeleton width="100%" height={56} borderRadius={60} marginBottom={8} />
    </SkeletonArray>
  </div>
);

export default SkeletonSelectDefault;
